import { Box, TableCell, TableHead, TableRow } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledTableHead = styled(TableHead)(({ theme }) => ({}));

export const StyledHeaderCell = styled(TableCell)(({ theme }) => ({
  color: theme.palette.common.white,
  fontWeight: "bold",
  borderBottom: "none",
  padding: 8,
  backgroundColor: "#0B3095",
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: 8,
  borderBottom: "1px solid #e0e0e0",
  textTransform: "uppercase",
  fontSize: 13,
}));

export const StyledEntityCell = styled(StyledTableCell)(({ theme }) => ({
  backgroundColor: "#ef4c3a ",
  color: theme.palette.common.white,
}));

export const StyledBox = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: 1230,
  marginLeft: "auto",
  marginRight: "auto",
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#fafafa",
  },

  "&:hover": {
    backgroundColor: "#eef3ff",
    transition: "background-color 0.15s ease",
  },
}));
